import React from "react";
import { DataGrid, DataGridProps } from "@mui/x-data-grid";
import "../../css/tables.css";

export default function FrontlineDataGrid(props: DataGridProps) {
  const { className, initialState, pageSizeOptions, ...gridProps } = props;

  return (
    <DataGrid
      autoHeight
      disableRowSelectionOnClick
      pageSizeOptions={pageSizeOptions ?? [10, 25, 50]}
      initialState={
        initialState ?? {
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }
      }
      rowHeight={52}
      density="standard"
      className={["frontline-grid", className].filter(Boolean).join(" ")}
      {...gridProps}
    />
  );
}
